import vars from '../../../theme/vars';

const { colors, headings } = vars;

const navigationBarStyle = {
  containerStyle: {
    backgroundColor: colors.white,
    paddingLeft: 14,
    paddingRight: 30,
    height: 40,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tabText: {
    ...headings.footer,
    textTransform: 'uppercase',
  },
};

export default navigationBarStyle;
